//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "my__links",
  data() {
    const domain = process.env.VUE_APP_SYHREF
      ? process.env.VUE_APP_SYHREF
      : "http://localhost:8080/";
    /** 服务协议 */
    const serviceAgreementPdf =
      "https://static.soyoung.com/sy-pre/33oqpfw3lc7q3-1646212200700.pdf";
    const serviceAgreementUrl = `${encodeURIComponent(
      serviceAgreementPdf
    )}`;
    /** 隐私政策 */
    const privacyPdf =
      "https://static.soyoung.com/sy-pre/nispvk91jre-1645668600705.pdf";
    const privacyUrl = `${encodeURIComponent(
      privacyPdf
    )}`;
    return {
      links: [
        {
          key: "service-agreement",
          icon:
            "https://static.soyoung.com/sy-pre/service-agreement-1677737400779.png",
          name: "服务协议",
          path: {
            path: "/webpdf",
            query: {
              file: serviceAgreementUrl,
              flag: "postdisable",
            },
          },
          statisticKey: "insur_mall_my_agreement_click",
        },
        {
          key: "privacy",
          icon: "https://static.soyoung.com/sy-pre/privacy-1677737400779.png",
          name: "隐私政策",
          path: {
            path: "/webpdf",
            query: {
              file: privacyUrl,
              flag: "postdisable",
            },
          },
        },
        {
          key: "info-expose",
          icon:
            "https://static.soyoung.com/sy-pre/info-expose-1677737400779.png",
          name: "信息披露",
          path:
            process.env.VUE_APP_ENV_TEST === "true"
              ? "http://10.10.20.66:18022/#/"
              : "http://www.chinaceib.com",
          statisticKey: "insur_mall_my_disclosure_click",
        },
        {
          key: "about-us",
          icon: "https://static.soyoung.com/sy-pre/about-us-1677737400779.png",
          name: "关于我们",
          path: `/general_purpose_material_detail?id=${process.env
            .VUE_APP_ABOUT_US_ID || "19"}`,
          statisticKey: "insur_mall_my_aboutus_click",
        },
      ],
    };
  },
  methods: {
    redirect(path, { statisticKey }) {
      if (statisticKey) {
        this.STATISTICS("click", statisticKey, "jr");
      }
      if (
        typeof path === "string" &&
        (path.startsWith("http:") || path.startsWith("https:"))
      ) {
        window.location = path;
      } else {
        this.$router.push(path);
      }
    },
  },
};
